import { AgreementPo } from '@/po/agreement';

export type UserContractType = {
  isAgreed: boolean,
  agreements: AgreementPo[]
}

export type GeneralContracts = {
  agreements: AgreementPo[]
}

/** 协议的类型，用于区分臻有钱用户协议展示几份 */
export enum AgreementSceneType {
  /** 短信外投场景 */
  SMS = 2,
  /** 默认值 */
  DEFAULT = 1
}

/**
 * 注册用户平台协议列表
 */
export interface RegisterUserAgreement {
  agreementId?: string;
  agreementName?: string;
  versionNo?: number;
  agreementScene?: number;
  agreementUrl?: string;
}

/**
 * 通用接口(哈臻快a面)-协议留痕入参结构
 */
export interface GeneralMarkOneAgreement {
  agreementIds: number[];
  agreementSource: number;
}

/** 哈臻快协议类型：ab面 */
export enum RechargeAppContractTypeEnums {
  TYPE_A = 1,
  TYPE_B = 2,
}
